import { ModuleAssignmentFields } from '@/components/common/ModuleAssignmentFields'
import { HelpText } from '@/components/common/help/HelpText'
import { helpKey } from '@/lib/action-modules/help'
import type { EditorActionModule } from '@/lib/action-modules/registry/types'

interface Props {
  value: EditorActionModule
  onChanged: (value: Partial<EditorActionModule>) => void
}

// Company-wide flag OR group assignment (shared with the service-module editor via
// ModuleAssignmentFields). Existing employee assignments are preserved through save.
export default function AssignmentTab({ value, onChanged }: Props) {
  return (
    <div className="flex flex-col gap-3 p-4">
      <ModuleAssignmentFields
        isCompanyWide={value.isCompanyWideAssigned}
        onCompanyWideChange={v => onChanged({ isCompanyWideAssigned: v })}
        selectedGroupIds={value.assignedGroupIds}
        onGroupsChange={ids => onChanged({ assignedGroupIds: ids })}
        selectedEmployeeIds={value.assignedEmployeeUserIds}
        onEmployeesChange={ids => onChanged({ assignedEmployeeUserIds: ids })}
      />
      <HelpText helpKey={helpKey('assignment')} />
    </div>
  )
}
